module.exports = __webpack_public_path__ + "img/esc_5_act_1.753d8426.png";